var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFBene1Cp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Dise\xF1o",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    fill: "#4a46ab"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Money_Bag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2,33.27l2.92-5.85c.32-.62.28-1.36-.08-1.96-.36-.58-1-.94-1.7-.94h-11.99c-.7,0-1.34.36-1.7.94-.36.6-.4,1.34-.08,1.96l2.92,5.85c-6.45,2.06-11.13,8.11-11.13,15.23v9.99c0,3.3,2.7,5.99,5.99,5.99h19.98c3.3,0,5.99-2.7,5.99-5.99v-9.99c0-7.11-4.68-13.17-11.13-15.23ZM41.35,50.5c-1.1,0-2-.9-2-2v-5.99c0-1.1.9-2,2-2h2c0-1.1.9-2,2-2s2,.9,2,2h2c1.1,0,2,.9,2,2s-.9,2-2,2h-5.99v2h5.99c1.1,0,2,.9,2,2v5.99c0,1.1-.9,2-2,2h-2c0,1.1-.9,2-2,2s-2-.9-2-2h-2c-1.1,0-2-.9-2-2s.9-2,2-2h5.99v-2h-5.99Z",
    fill: "#4a46ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFBene1Cp);
export default __webpack_public_path__ + "static/media/F-Bene1-CP.9e37ae6d59c514588b5e6c0d654be195.svg";
export { ForwardRef as ReactComponent };